import './CodeSnippet.css';
import React from 'react';
import { get } from "../../utils";
// https://stackoverflow.com/questions/14644558/call-javascript-function-after-script-is-loaded
function loadScript(url, callback) {
  var script = document.createElement("script");
  script.type = "text/javascript";
  if (script.readyState) {
    // only required for IE <9
    script.onreadystatechange = function () {
      if (script.readyState === "loaded" || script.readyState === "complete") {
        script.onreadystatechange = null;
        callback();
      }
    };
  } else {
    //Others
    script.onload = function () {
      callback();
    };
  }
  script.src = url;
  document.getElementsByTagName("head")[0].appendChild(script);
}
var CodeSnippet = function CodeSnippet(_ref) {
  var fields = _ref.fields,
    params = _ref.params;
  var ref = React.useRef();
  var snippet = get(fields, 'data.item.code.jss.value', '');
  var scripts = get(fields, 'data.item.scripts.jss.value', '');
  React.useEffect(function () {
    var strt = scripts.indexOf('src="');
    var end = scripts.indexOf('">', strt);
    var scriptLib = scripts.slice(strt + 5, end);
    loadScript(scriptLib, function () {
      var script = document.createElement('script');
      var strt = scripts.indexOf('<script>', end);
      var end2 = scripts.indexOf('</script>', strt);
      script.innerHTML = scripts.slice(strt + 8, end2);
      ref.current.appendChild(script);
    });
    return function () {
      ref.current.innerHTML = '';
    };
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    className: commonStyles,
    ref: ref,
    dangerouslySetInnerHTML: {
      __html: snippet
    }
  });
};
export var commonStyles = "c10att56";
export default CodeSnippet;